import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { update_tag } from '../redux/reducers';
import { createTags } from '../redux/selectors';

const TagList = ({ tags }) => {
  const [expandedTagId, setExpandedTagId] = useState(null);
  const loading = useSelector(createTags);
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    let data = {
      ...values
    };
    if (data?._id) delete data?._id;
    dispatch(update_tag({ id: values?._id, data }));
  };
  return (
    <div className="space-y-3">
      {tags.map((tag) => {
        const isOpen = expandedTagId === tag._id;

        return (
          <div key={tag._id} className="p-3 rounded border">
            {/* 🔹 SHOW LESS (ROW) */}
            <div
              className="flex justify-between cursor-pointer"
              onClick={() => setExpandedTagId(isOpen ? null : tag._id)}
            >
              <div>
                <p className="font-medium">{tag.name}</p>
                <p className="text-xs text-gray-500">
                  Priority: {tag.display_priority ?? '-'}
                </p>
              </div>

              <span>{isOpen ? 'Hide' : 'Edit'}</span>
            </div>

            {/* 🔥 EXPANDED FORM */}
            {isOpen && (
              <div className="pt-3 mt-3 border-t">
                <Formik
                  initialValues={tag}
                  onSubmit={(values) => {
                    handleSubmit(values); // hook to redux mutation
                  }}
                >
                  {() => (
                    <Form className="space-y-2">
                      <Field
                        name="category"
                        className="p-2 w-full rounded border"
                        placeholder="Category"
                      />
                      <Field
                        name="name"
                        className="p-2 w-full rounded border"
                        placeholder="Tag name"
                      />

                      <Field
                        name="description"
                        className="p-2 w-full rounded border"
                        placeholder="Description"
                      />
                      {/* ONBOARDING */}
                      <Field
                        as="select"
                        name="onboarding"
                        className="p-2 w-full rounded border"
                      >
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                        <option value="Optional">Optional</option>
                      </Field>

                      {/* CHECKBOXES */}
                      <div className="flex gap-4">
                        <label className="flex gap-2 items-center">
                          <Field type="checkbox" name="meal_card_display" />
                          Meal Card
                        </label>

                        <label className="flex gap-2 items-center">
                          <Field type="checkbox" name="homepage_inspiration" />
                          Homepage
                        </label>
                      </div>

                      <Field
                        type="number"
                        name="display_priority"
                        className="p-2 w-full rounded border"
                        placeholder="Priority"
                      />

                      <Field
                        type="number"
                        name="max_tags_per_meal_card"
                        className="p-2 w-full rounded border"
                        placeholder="Max Tags Per Meal Card"
                      />

                      <button
                        type="submit"
                        disabled={isOpen && loading}
                        className="px-3 py-1 text-white bg-[#549a9a] rounded disabled:opacity-50"
                      >
                        {isOpen && loading ? 'Saving...' : 'Save'}
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TagList;
